import { render, staticRenderFns } from "./IndexButtons.vue?vue&type=template&id=9c7efda8"
import script from "./IndexButtons.vue?vue&type=script&lang=js"
export * from "./IndexButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports